<a href="#" [routerLink]="targetRoute" class="button primary-nav__cta">{{buttonTitle}}</a>